<template>
  <div class="search-form p-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <div class="row">
      <div class="col-sm-6">
          <span class="span-title">{{ $t('material_station.name') }}</span>
          <input
              v-model="name"
              type="text"
              class="form-control form-control-sm"
          />
      </div>
    </div>
    <div class="col-sm-12 button-container">
      <button
        class="btn btn-primary form-button"
        size="sm"
        @click.stop="emitSearch"
      >
        {{ $t('ins_report.search') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'MaterialStationSearch',
    data: function () {
        return {
            name: null,
        }
    },
    methods: {
        emitSearch: function () {
            this.$emit('search', {name: this.name})
        }
    }
}
</script>
